import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';

import { RUN_MODE_TOKEN, RunMode } from 'src/environments/runtime';

import { EndpointService } from '../services/endpoint/endpoint.service';

@Injectable()
export class DeviceHeaderInterceptor implements HttpInterceptor {
  constructor(
    private endpointService: EndpointService,
    @Optional() @Inject(RUN_MODE_TOKEN) private runMode: RunMode | null
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.runMode === 'cloud' && this.endpointService.nodeId) {
      const modifiedReq = req.clone({
        setHeaders: {
          'X-Device-Id': this.endpointService.nodeId,
        },
      });
      return next.handle(modifiedReq);
    }
    return next.handle(req);
  }
}
